module.exports = __webpack_public_path__ + "img/tag.87e4ad11.svg";